import { Map, fromJS } from 'immutable'
import { handleActions } from 'redux-actions'
import ActionHelper from 'helpers/action'

export const FETCH_JOB_INPUT_GROUP_TABLE_DATA =
  'jobInputsAdmin/FETCH_JOB_INPUT_GROUP_TABLE_DATA'
export const [
  FETCH_JOB_INPUT_GROUP_TABLE_DATA_SUCCESS,
  FETCH_JOB_INPUT_GROUP_TABLE_DATA_FAILURE,
] = [
  `${FETCH_JOB_INPUT_GROUP_TABLE_DATA}_SUCCESS`,
  `${FETCH_JOB_INPUT_GROUP_TABLE_DATA}_FAILURE`,
]

export const FETCH_JOB_WORKFLOW_INPUT_GROUP_ITEM =
  'jobInputsAdmin/FETCH_JOB_WORKFLOW_INPUT_GROUP_ITEM'
export const [
  FETCH_JOB_WORKFLOW_INPUT_GROUP_ITEM_SUCCESS,
  FETCH_JOB_WORKFLOW_INPUT_GROUP_ITEM_FAILURE,
] = [
  `${FETCH_JOB_WORKFLOW_INPUT_GROUP_ITEM}_SUCCESS`,
  `${FETCH_JOB_WORKFLOW_INPUT_GROUP_ITEM}_FAILURE`,
]

export const SAVE_JOB_INPUT_GROUPS_INFO =
  'jobInputsAdmin/SAVE_JOB_INPUT_GROUPS_INFO'
export const DELETE_JOB_INPUT_GROUP_ITEM =
  'jobInputsAdmin/DELETE_JOB_INPUT_GROUP_ITEM'
export const JOB_INPUT_GROUPS_CLEAR_STORE =
  'jobInputsAdmin/JOB_INPUT_GROUPS_CLEAR_STORE'
export const JOB_INPUT_GROUPS_CLEAR_DETAILS =
  'jobInputsAdmin/JOB_INPUT_GROUPS_CLEAR_DETAILS'

export const fetchJobInputGroupData = ActionHelper.createActionObj(
  FETCH_JOB_INPUT_GROUP_TABLE_DATA,
)
export const fetchJobWorkflowInputGroupItem = ActionHelper.createActionObj(
  FETCH_JOB_WORKFLOW_INPUT_GROUP_ITEM,
)
export const saveJobInputGroupsInfo = ActionHelper.createActionObj(
  SAVE_JOB_INPUT_GROUPS_INFO,
)
export const deleteJobInputGroupItem = ActionHelper.createActionObj(
  DELETE_JOB_INPUT_GROUP_ITEM,
)
export const jobInputGroupsClearStore = ActionHelper.createActionObj(
  JOB_INPUT_GROUPS_CLEAR_STORE,
)
export const jobInputGroupsClearDetails = ActionHelper.createActionObj(
  JOB_INPUT_GROUPS_CLEAR_DETAILS,
)

const initialState = () =>
  fromJS({
    isLoadingTableData: false,
    isLoadingFormData: false,
    tableData: Map({}),
    formData: Map({}),
  })

const jobInputGroupsAdmin = handleActions(
  {
    [FETCH_JOB_INPUT_GROUP_TABLE_DATA]: state =>
      state.set('isLoadingTableData', true),
    [FETCH_JOB_INPUT_GROUP_TABLE_DATA_SUCCESS]: (state, action) =>
      state
        .set('isLoadingTableData', false)
        .set('tableData', Map(action.payload)),
    [FETCH_JOB_INPUT_GROUP_TABLE_DATA_FAILURE]: state =>
      state
        .set('isLoadingTableData', false)
        .set('tableData', initialState().get('tableData')),
    [FETCH_JOB_WORKFLOW_INPUT_GROUP_ITEM]: state =>
      state.set('isLoadingFormData', true),
    [FETCH_JOB_WORKFLOW_INPUT_GROUP_ITEM_SUCCESS]: (state, action) =>
      state
        .set('isLoadingFormData', false)
        .set('formData', Map(action.payload)),
    [FETCH_JOB_WORKFLOW_INPUT_GROUP_ITEM_FAILURE]: state =>
      state
        .set('isLoadingFormData', false)
        .set('formData', initialState().get('formData')),
    [JOB_INPUT_GROUPS_CLEAR_DETAILS]: state =>
      state.set('formData', initialState().get('formData')),
    [JOB_INPUT_GROUPS_CLEAR_STORE]: () => initialState(),
  },
  initialState(),
)

export default jobInputGroupsAdmin
